import * as productGroupsActions from '../actions/product-groups.actions';
import { ProductGroupModel } from 'app/models/product-group-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  productGroups: ProductGroupModel[];
  isLoading: boolean;
  isLoaded: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  productGroups: [],
  isLoading: false,
  isLoaded: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(productGroupsActions.loadProductGroups, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    productGroupsActions.loadProductGroupsSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      productGroups: response,
    })
  ),
  on(
    productGroupsActions.createProductGroup,
    productGroupsActions.updateProductGroup,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    productGroupsActions.createProductGroupSuccess,
    productGroupsActions.createProductGroupFailed,
    productGroupsActions.updateProductGroupSuccess,
    productGroupsActions.updateProductGroupFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    productGroupsActions.resetProductGroups,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
